/**
 * Service for V2 extraction API calls
 */

import {
	DashboardMetricsResponse,
	ExtractionStatusResponse,
	ProjectExtractionResponse,
	StartExtractionRequest,
} from "../types/extraction-v2";
import { apiFetch } from "../utils/apiClient";
import { getApiBaseURLFromEnv } from "../utils/env";

class ExtractionV2Service {
	private get baseUrl() {
		// V2 APIs are at /api/v2, not under /api/v1
		return `${getApiBaseURLFromEnv()}/api/v2`;
	}

	/**
	 * Start extraction for a project
	 */
	async startExtraction(
		request: StartExtractionRequest = { project_id: "" },
	): Promise<ProjectExtractionResponse> {
		const url = `${getApiBaseURLFromEnv()}/api/v3/extract`;
		console.log(`[ExtractionV2Service] Starting extraction at: ${url}`);
		console.log(`[ExtractionV2Service] Request body:`, request);
		const response = await apiFetch(url, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(request),
		});
		if (!response.ok) {
			const errorText = await response.text();
			console.error(`[ExtractionV2Service] Error response:`, errorText);
			throw new Error(
				`Start extraction failed: ${response.status} - ${errorText}`,
			);
		}
		return await response.json();
	}

	/**
	 * Get extraction status for a project
	 */
	async getExtractionStatus(
		projectId: string,
	): Promise<ExtractionStatusResponse> {
		const url = `${this.baseUrl}/projects/${projectId}/extraction-status`;
		console.log(`[ExtractionV2Service] Fetching status from: ${url}`);
		const response = await apiFetch(url);
		if (!response.ok) {
			throw new Error(`Get extraction status failed: ${response.status}`);
		}
		return await response.json();
	}

	/**
	 * Get dashboard metrics for a project (from completed extraction)
	 */
	async getDashboardMetrics(
		projectId: string,
	): Promise<DashboardMetricsResponse> {
		const url = `${this.baseUrl}/projects/${projectId}/dashboard`;
		console.log(`[ExtractionV2Service] Fetching dashboard from: ${url}`);
		const response = await apiFetch(url);
		if (!response.ok) {
			throw new Error(`Get dashboard metrics failed: ${response.status}`);
		}
		return await response.json();
	}
}

export const extractionV2Service = new ExtractionV2Service();
export default extractionV2Service;
